import dayjs from 'dayjs';
import ruLocale from 'dayjs/locale/ru';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { convertDatePickerToISO } from '../../helpers/convertDate';
import { parseDocumentNumber } from '../../helpers/parseDocumentNumber';
dayjs.extend(customParseFormat);
dayjs.locale(ruLocale);
export const getIdentityDocumentView = (doc) => {
    return {
        id: doc.id,
        code: doc.type || '',
        number: [doc.series, doc.number].join(' ').trim(),
        issuer: doc.issuer || '',
        issuerUnitCode: doc.issuerUnitCode || '',
        validityPeriodBegin: doc.validityPeriod?.begin || '',
        validityPeriodEnd: doc.validityPeriod?.end || '',
        driversCategories: doc.driversCategories || [],
    };
};
export const getIdentityDocumentType = (code, docReferences) => {
    const type = docReferences.find((el) => el.code === code)?.name || '';
    return addNbsp(type);
};
export const checkIsIdentityDocumentActive = (begin, end) => {
    const today = dayjs(dayjs().format('YYYY-MM-DD'));
    if (begin && today.isBefore(dayjs(begin, ['DD.MM.YYYY', 'YYYY-MM-DD']))) {
        return false;
    }
    if (end && today.isAfter(dayjs(end, ['DD.MM.YYYY', 'YYYY-MM-DD']))) {
        return false;
    }
    return true;
};
const addNbsp = (words) => {
    const special = ['—', '-', 'РФ'];
    return words
        .split(' ')
        .reduce((acc, cur, index, arr) => {
        const wordBefore = arr[index - 1] || '';
        const space = wordBefore.length < 3 || special.includes(cur) ? '\xa0' : ' ';
        return acc + space + cur;
    }, '')
        .trim();
};
export const formatDateString = (date) => {
    if (!date) {
        return '';
    }
    return dayjs(convertDatePickerToISO(date)).locale('ru').format('DD MMM YYYY').replace('.', '');
};
export const getIdentityDocumentRequest = (document) => {
    const numberAndSeries = parseDocumentNumber({ documentNumber: document.number, documentType: document.code });
    return {
        type: document.code,
        validityPeriod: {
            begin: document.validityPeriodBegin,
            end: document.validityPeriodEnd,
        },
        issuer: document.issuer,
        issuerUnitCode: document.issuerUnitCode,
        series: numberAndSeries.series,
        number: numberAndSeries.number,
        driversCategories: document.driversCategories,
    };
};
